<template lang="pug">
ValidationProvider(name="Eigentümer" :rules="rules" v-slot="{ errors, valid }")
  b-field(label="Eigentümer" label-position="on-border"
          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
    b-select(v-model="innerValue")
      option(v-for="owner in owners" :value="owner.id") {{owner.fullName}}
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: "required"
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  computed: {
    owners() {
      return this.$store.state.owners.all;
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  async mounted() {
    await this.$store.dispatch("owners/findAll");
  }
};
</script>